import { Stack, Text, Box, Inline } from '@machobear/design-system'

import { ReactElement, ReactNode } from 'react'

export const FormBox = ({
  children,
  label,
  description,
  icon,
  secondaryLabel
}: {
  children: any
  label: string
  description?: string
  icon?: any
  secondaryLabel?: any
}) => {
  return (
    <Box
      paddingY="xlarge"
      paddingX="large"
      background="white"
      borderRadius="standard"
      role="listitem"
      aria-label={label}
    >
      <Stack space="large">
        <Stack space="small">
          <Box display={'flex'} justifyContent={'spaceBetween'} alignItems={'center'}>
            {icon ? (
              <Box display="flex" alignItems="center" gap="small">
                <Text size="large" weight="strong">
                  {label}
                </Text>
                {icon}
              </Box>
            ) : (
              <Text size="large" weight="strong">
                {label}
              </Text>
            )}
            {secondaryLabel ? <Inline space="none">{secondaryLabel}</Inline> : null}
          </Box>

          {description ? (
            <Text size="small" tone="secondary">
              {description}
            </Text>
          ) : null}
        </Stack>
        {children}
      </Stack>
    </Box>
  )
}

export const FormRow = ({
  children,
  label,
  description,
  optionText,
  listNumber,
  tooltip
}: {
  listNumber?: number
  children: any
  label?: string
  description?: string
  optionText?: ReactElement | null
  tooltip?: ReactNode
}) => {
  return (
    <Stack space="gutter" align="left">
      <Stack space="small">
        <Box
          display="flex"
          justifyContent="spaceBetween"
          alignItems={{ mobile: 'flexStart', tablet: 'center' }}
          flexDirection={{ mobile: 'column', tablet: 'row' }}
        >
          <Inline space={'small'} align={'left'}>
            {listNumber ? <Text>{listNumber}.</Text> : null}
            <Text size="medium" weight="medium">
              {label}
            </Text>
          </Inline>

          {optionText && (
            <Inline space={'none'} align={'right'}>
              {optionText}
            </Inline>
          )}
        </Box>
        {description ? (
          <Text tone="secondary" size="small">
            {description}
          </Text>
        ) : null}
      </Stack>

      <Stack space="xsmall" align="left">
        {children}
        {tooltip ? tooltip : null}
      </Stack>
    </Stack>
  )
}
